import { selectIsLoggedIn } from '../store/auth/selectors';
import { useSelector } from '../store/store';
import { FC } from 'react';
import {
    Outlet,
    Navigate,
    useLocation,
} from 'react-router-dom';

export const PrivateRoute: FC = () => {
    const location = useLocation();
    const isLoggedIn = useSelector(selectIsLoggedIn);

    return (isLoggedIn ? <Outlet /> : <Navigate to='/signin' state={{ from: location.pathname }} replace />);
};